import { Typography } from '@material-ui/core'

const InfoWrapper = (props) => {
  if (props.value === null) return null
  if (props.value === undefined) return null
  if (props.value === '') return null
  return (
    <Typography variant="subtitle2">
      {props.title} : {props.value}
    </Typography>
  )
}
export default InfoWrapper
